export const About = ()=>{
    return(
        <section id="about">
            <div className="container-fluid">
                
                <div className="row align-items-center">
                    
                    <div className="col-md-6">
                        <div className="animate-up">
                            <h2>About Us</h2>
                        <p >
                            Dewhyno building construction limited is a premium construction and project delivery firm
                            dedicated to excellence, innovation, and superiior craftsmanship. We provide bespoke construction
                            solutions tailored to meet the unique needs of discerning clients who value quality,
                            precision and reliability.
                            Our expertise spans building production management, project execution, and facility management,
                            all driven by a structured approach that integrates detailed construction programmes.
                        </p>
                        </div>
                       
                       
                      
                    </div>
                    <div className="col-md-6">
                        <div className="about-container-image animate-up"></div>
                        
                    </div>
                </div>
            </div>
        </section>
    )
}